// src/api/request.js
import axios from "axios";
import router from "../router";
import { Message } from 'element-ui';
import Const from "@/utils/consts";

// 创建 axios 实例
const request = axios.create({
  baseURL: "/v1",
  timeout: 20000,
});

// 异常拦截处理器
const errorHandler = (error) => {
  console.error("Request error:", error);

  if (error.response) {
    const { status, data } = error.response;

    switch (status) {
      case 401:
        Message.warning(data?.msg || "Unauthorized");
        // 清除用户信息并跳转
        localStorage.removeItem(Const.KEY_TOKEN);
        localStorage.removeItem(Const.KEY_INFO);
        // 避免在路由守卫中重复跳转
        if (router.currentRoute.value.name !== "index") {
          router.push({ name: "index" });
        }
        break;
      case 500:
      case 404:
        Message.error("Server exception");
        break;
      default:
        Message.error(data?.msg || "Request failed");
    }
  } else if (error.request) {
    // 请求发出但没有收到响应
    Message.error("Network error, please check your connection");
  } else {
    // 请求配置出错
    Message.error(error.message || "Request configuration error");
  }

  return Promise.reject(error);
};

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 添加 token
    const token = localStorage.getItem(Const.KEY_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 多语言处理
    try {
      const language = JSON.parse(
        localStorage.getItem(Const.KEY_LANG) || "null",
      );
      config.headers["Accept-Language"] = language?.lang
        ? `${language.lang},en;q=0.9`
        : "en;q=0.9";
    } catch (e) {
      config.headers["Accept-Language"] = "en;q=0.9";
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// 响应拦截器
request.interceptors.response.use((response) => {
  // 检查业务状态码
  if (response.data.code === 0 || response.data.code === 200) {
    return response.data;
  }

  // 处理特殊业务错误
  if (response.data.code === 1000) {
    Message.warning(response.data.msg || "Business error");
    return Promise.reject(response.data);
  }

  // 其他业务错误
  if (response.data.code && response.data.code !== 1) {
    Message.error(response.data.msg || `Error code: ${response.data.code}`);
    return Promise.reject(response.data);
  }

  // code === 1 或其他情况，直接返回数据
  return response.data;
}, errorHandler);

export default request;
